import { render, staticRenderFns } from "./TouchForFabricatorsPage.vue?vue&type=template&id=a5b3fddc&"
import script from "./TouchForFabricatorsPage.vue?vue&type=script&lang=js&"
export * from "./TouchForFabricatorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports